import { signInWithEmailAndPassword, createUserWithEmailAndPassword, signOut } from "firebase/auth";
import { auth, database } from "../utils/fipresConfig";
import { setDoc, doc, deleteDoc, collection } from "firebase/firestore";

export const registerUser = async (name, email, password) => {
    try {
        const res = await createUserWithEmailAndPassword(auth, email, password);
        const user = res.user;
        await setDoc(doc(database, "users", user.uid), {
            email: user.email,
            name: name,
            isAdmin: false,
        });
        return { success: true };
    } catch (error) {
        return { success: false, error: error.message };
    }
};

export const signInUser = async (email, password) => {
    try {
        await signInWithEmailAndPassword(auth, email, password);
        return { success: true };
    } catch (error) {
        return { success: false, error: error.message };
    }
};

export const signOutUser = async () => {
    try {
        await signOut(auth);
        return { success: true };
    } catch (error) {
        return { success: false, error: error.message };
    }
};

export function getFrontendErrorMessage(errorCode) {
    switch (errorCode) {
        case "Firebase: Error (auth/user-not-found).":
            return "This email is not registered, please make sure you enter a registered email.";
        case "Firebase: Error (auth/wrong-password).":
            return "The password entered is wrong. Please make sure you enter the correct password.";
        case "Firebase: Password should be at least 6 characters (auth/weak-password).":
            return "The password should be at least 6 characters.";
        case "Firebase: Error (auth/email-already-in-use).":
            return "The email address is already in use. Please use a different email.";
        case "Firebase: Error (auth/invalid-email).":
            return "Invalid email address. Please enter a valid email.";
        case "Firebase: Error (auth/weak-password).":
            return "Weak password. Please choose a stronger password.";
        case "Firebase: Error (auth/invalid-login-credentials).":
            return "Incorrect credentials, please make sure you add correct ones.";
        case "Firebase: Error (auth/operation-not-allowed).":
            return "This operation is currently not allowed. Please try again later.";
        case "Firebase: Error (auth/too-many-requests).":
            return "Too many requests, please try again in some minutes.";
        case "Firebase: Error (auth/app-not-authorized).":
            return "The app is not authorized to use Firebase Authentication.";
        case "Firebase: Error (auth/network-request-failed).":
            return "Network error. Please check your internet connection and try again.";
        case "Firebase: Error (auth/requires-recent-login).":
            return "Please log in again to continue.";
        case "Firebase: Error (auth/invalid-api-key).":
            return "Invalid API key. Please contact support.";
        default:
            return "An error occurred. Please try again.";
    }
}

// New functions from formadmin.js

export const handleDataFile = async (id, name, image, title, text, link, textlink) => {
    try {
        const primaryKey = id || doc(collection(database, "books")).id;
        const docRef = doc(database, "books", primaryKey);
        await setDoc(docRef, {
            name,
            image,
            title,
            text,
            link,
            textlink,
            primaryKey: "file",
            updatedAt: new Date()
        });
        return { success: true };
    } catch (error) {
        return { success: false, error: error.message };
    }
};

export const handleDataProject = async (id, title, image, link, textlink) => {
    try {
        if (!title || !image || !link || !textlink) {
            throw new Error("Please fill in all fields.");
        }

        const primaryKey = id || doc(collection(database, "books")).id;
        const docRef = doc(database, "books", primaryKey);
        await setDoc(docRef, {
            title,
            image,
            link,
            textlink,
            primaryKey: "project",
        });
        return { success: true };
    } catch (error) {
        return { success: false, error: error.message };
    }
};

export const handleDataNews = async (id, title) => {
    try {
        if (!title) {
            throw new Error("Please fill in all fields.");
        }

        const primaryKey = id || "xATBKPou3FcZt3jSB4ka"; // استخدام المعرف الثابت
        const docRef = doc(database, "books", primaryKey);
        await setDoc(docRef, {
            title: title,
            primaryKey: "news",
        }, { merge: true }); // استخدام merge لتحديث الحقل بدلاً من إضافة حقل جديد
        return { success: true };
    } catch (error) {
        return { success: false, error: error.message };
    }
};

export const handleEdit = (doc) => {
    return {
        name: doc.name,
        id: doc.id,
    };
};

export const handleDelete = async (id) => {
    try {
        await deleteDoc(doc(database, "books", id));
        return { success: true };
    } catch (error) {
        return { success: false, error: error.message };
    }
};


